var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.productsEnhanced.length && _vm.selectedProduct
    ? _c("div", { staticClass: "highlight-products" }, [
        _c("div", { staticClass: "highlight-products__image" }, [
          _c(
            "figure",
            { staticClass: "highlight-products__image-wrapper" },
            _vm._l(_vm.productsEnhanced, function (product) {
              return _c("img", {
                key: "highlight-image-" + product.code,
                staticClass: "highlight-products__image-element",
                class: {
                  "highlight-products__image-element--active":
                    _vm.selectedProductCode == product.code,
                },
                attrs: { src: product.image, alt: "Product Image" },
              })
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "highlight-products__content",
            class: [_vm.bgColorClass],
          },
          [
            _c(
              "nav",
              { staticClass: "highlight-products__bullets" },
              _vm._l(_vm.productsEnhanced, function (product, index) {
                return _c(
                  "button",
                  {
                    key: "highlight-bullet-" + product.code,
                    staticClass: "highlight-products__bullet",
                    class: {
                      "highlight-products__bullet--active":
                        _vm.selectedProductCode == product.code,
                      "highlight-products__bullet--pulsate":
                        _vm.selectedProductCode == product.code && !_vm.clicked,
                    },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.onBulletClick(product)
                      },
                    },
                  },
                  [
                    _c("SVGDumpling", {
                      staticClass: "highlight-products__bullet-icon",
                    }),
                  ],
                  1
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "highlight-products__details" },
              [
                _c("h3", {
                  staticClass: "highlight-products__details-title",
                  domProps: { innerHTML: _vm._s(_vm.selectedProduct.name) },
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "highlight-products__details-description",
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.selectedProduct.description ||
                        _vm.selectedProduct.shortDescription
                    ),
                  },
                }),
                _vm._v(" "),
                _vm.hasBasket &&
                _vm.isAvailable &&
                !_vm.selectedProduct.isEditable &&
                !_vm.selectedProduct.isConfigurable
                  ? _c("Button", {
                      staticClass: "highlight-products__details-button",
                      attrs: {
                        level: "primary",
                        type: "button",
                        text: _vm.$t("shoplist.product.addToCart"),
                        disabled: _vm.locked,
                        variants: ["small"],
                      },
                      on: {
                        click: function ($event) {
                          return _vm.onCart()
                        },
                      },
                    })
                  : !_vm.hasBasket
                  ? _c("Button", {
                      staticClass: "highlight-products__details-button",
                      attrs: {
                        level: "primary",
                        type: "button",
                        text: _vm.$t("shoplist.product.toShop"),
                        variants: ["small"],
                      },
                      on: {
                        click: function ($event) {
                          return _vm.goToShop()
                        },
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasBasket && _vm.addedToCart
                  ? _c("div", {
                      staticClass: "highlight-products__cart-notification",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.$t("shoplist.product.successCart")
                        ),
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }